import { ISelectStatus } from '@base/cart/interface';

export const GROUP_TYPE_SUPER_SLOTS = 'slotMachineGroup';
export const GROUP_TYPE_REDEEM_REWARDS = 'redeemRewardsGroup';

// 可被勾选的Select Status
export const CAN_SELECT_STATUS: ISelectStatus[] = [1, 2];